import cart from '@/public/images/icons/cart.svg';
import money from '@/public/images/icons/money.svg';
import surfaces from '@/public/images/icons/surfaces.svg';
import chat from '@/public/images/icons/chats.svg';

import devices from '@/public/images/icons/devices.svg';
import laptop from '@/public/images/icons/laptop.svg';
import speed from '@/public/images/icons/speed.svg';
import update from '@/public/images/icons/updates.svg';
import browsers from '@/public/images/icons/browsers.svg';
import setup from '@/public/images/icons/setup.svg';

import fast from '@/public/images/icons/fast.svg';
import target from '@/public/images/icons/target.svg';
import cart2 from '@/public/images/icons/cart-2.svg';
import laptop2 from '@/public/images/icons/laptop-2.svg';

import layout from '@/public/images/icons/layout.svg';
import social from '@/public/images/icons/social.svg';
import details from '@/public/images/icons/details.svg';
import next from '@/public/images/icons/next.svg';

export const advHomeImport = [cart, money, surfaces, chat];

export const advThemeImport = [laptop, devices, speed, update, browsers, setup];

export const advSearchImport = [fast, target, cart2, laptop2];

export const advFeaturesImport = [speed, surfaces, money, cart];

export const advBlogImport = [layout, social, details, next];
